import React, { useEffect } from 'react';
import { Star, X } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

interface ReviewPromptProps {
  onClose: () => void;
}

const ReviewPrompt: React.FC<ReviewPromptProps> = ({ onClose }) => {
  const { t } = useLanguage();
  const googleReviewUrl = "https://search.google.com/local/writereview?placeid=ChIJORig4wIRuw0R41DhXm_9HEk";

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [onClose]);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="review-title"
        aria-describedby="review-description"
        className="relative bg-white rounded-2xl shadow-xl w-full max-w-md p-6"
      >
        <div className="flex flex-col items-center text-center">
          <button 
            onClick={onClose}
            aria-label="Close review prompt"
            className="absolute top-4 right-4 p-2 hover:bg-gray-100 rounded-full transition-colors"
          >
            <X size={24} className="text-gray-500" aria-hidden="true" />
          </button>
          
          <div className="flex gap-1 mb-4" aria-hidden="true">
            {[...Array(5)].map((_, i) => (
              <Star key={i} size={28} className="text-yellow-400 fill-yellow-400" />
            ))}
          </div>
          
          <h2 id="review-title" className="text-2xl font-bold text-gray-800 mb-3">
            {t('review.title')}
          </h2>
          
          <p id="review-description" className="text-gray-600 mb-6">
            {t('review.description')}
          </p>
          
          <div className="space-y-3 w-full">
            <a 
              href={googleReviewUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="block w-full bg-primary text-white py-3 px-6 rounded-xl font-semibold hover:bg-primary-dark transition-colors"
            >
              {t('review.leaveReview')}
            </a>
            
            <button
              onClick={onClose}
              className="w-full bg-gray-100 text-gray-700 py-3 px-6 rounded-xl font-semibold hover:bg-gray-200 transition-colors"
            >
              {t('review.maybeLater')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReviewPrompt; 